<!-- @file 商品标签组件 -->

<template>
  <div
    class="plv-iar-product__label pws-product-theme-tags-bg"
    :style="{
      maxWidth: maxWidth ? `${maxWidth}px`: 'none'
    }"
    :class="{'plv-iar-product__label--mobile': isMobile}"
    :title="text"
  >
    <span
      ref="labelContent"
      class="plv-iar-product__label__content "
    >{{ text }}</span>
  </div>
</template>

<script>
import { isMobile } from '@polyv/utils/src/browser';

export default {
  props: {
    text: {
      type: String,
      default: '',
    },

    tagWidth: {
      type: Number,
      default: 52
    },

    maxWidth: {
      type: Number,
      default: 50
    },
  },

  data() {
    return {
      width: 0,
      isMobile: isMobile(),
    };
  },

  watch: {
    text() {
      this.$nextTick(() => {
        this.setWidth();
      });
    }
  },

  mounted() {
    this.setWidth();
  },

  methods: {
    setWidth() {
      const contentDom = this.$refs.labelContent;
      // 内容宽度 * 0.83得到10px字体大小下的宽度，再加上左右的内边距12px
      this.width = contentDom.clientWidth * 0.83 + 12;
    }
  },
};
</script>

<style lang="scss">
.plv-iar-product__label {
  user-select: none;
  height: 18px;
  padding: 0;
  line-height: 18px;
  display: inline-block;
  flex-shrink: 0;
  position: relative;
  font-size: 12px;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.plv-iar-product__label__content {
  display: inline-block;
  transform: translate3d(0, 0, 0) scale(.83);
}

.plv-iar-product__label--mobile {
  // 移动端设置 10px 字体
  -webkit-text-size-adjust: 100%;
  font-size: 10px;

  .plv-iar-product__label__content {
    display: inline-block;
    transform: scale(1);
  }
}

.plv-iar-product__label--mobile.plv-iar-product__label {
  color: rgba(0, 0, 0, 0.6) !important;
  border-color: rgba(0, 0, 0, 0.2) !important;
}
</style>
